
const apiConfig = {
    // Local
    //apiUrl: 'https://localhost:7254/api/',
    // Live
    apiUrl: 'https://jkt-api.off-ease.com/api/',
    // Demo    
    //apiUrl: 'https://demo-api.off-ease.com/api/',
    apiKey: 'Lieda1002',
};

export default apiConfig;

